// extracted by mini-css-extract-plugin
export default {"container":"oK-z","dimension":"pK-z","dimensionLabels":"qK-z"};